import React from 'react';
import { ProRibbon, BetaRibbon } from '@udemy/react-messaging-components';
import { useUDData } from '@udemy/ud-data';
import styles from "./pro-badge.module.css";
/**
 * ### ProBadge
 *
 * @deprecated Use `ProRibbon` or `BetaRibbon` instead directly from `@udemy/react-messaging-components` instead.
 */
export const ProBadge = ({
  className = '',
  background = 'neutral',
  ...otherProps
}) => {
  const udData = useUDData();
  if (udData.Config.brand.has_organization) {
    return /*#__PURE__*/React.createElement(ProRibbon, Object.assign({
      className: className
    }, otherProps));
  }
  return /*#__PURE__*/React.createElement(BetaRibbon, Object.assign({
    className: `${className} ${styles[background]}`
  }, otherProps));
};
ProBadge.displayName = 'ProBadge';
//# sourceMappingURL=pro-badge.react-component.js.map